exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".slide-actions[data-v-6c009249]{position:absolute;top:.5em;right:.5em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/HeadersForm.vue"],"names":[],"mappings":"AACA,gCACE,kBAAmB,AACnB,SAAU,AACV,UAAY,CACb","file":"HeadersForm.vue","sourcesContent":["\n.slide-actions[data-v-6c009249] {\n  position: absolute;\n  top: .5em;\n  right: .5em;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c009249","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HeadersForm.vue
// module id = 972
// module chunks = 14